import { SxProps, Theme } from '@mui/material';

export const searchContainerStyles: SxProps<Theme> = {
  mb: 2,
  p: 2,
  bgcolor: 'background.paper',
  borderRadius: 1,
  boxShadow: 1, // Optional: adds a subtle shadow
};

export const noResultsStyles: SxProps<Theme> = {
  p: 2,
  textAlign: 'center',
  color: 'text.secondary', // Softer color for the message
};
